import { ROUTE_NAMES } from '@/constants/routes'

export const GROUP_TYPE = {
  TEAM: 'TEAM',
  ORG: 'ORG',
  CHILDORG: 'CHILDORG'
}

export const GROUP_MAP = {
  [GROUP_TYPE.TEAM]: {
    name: 'Team'
  },
  [GROUP_TYPE.CHILDORG]: {
    name: 'Child org',
    icon: 'child-org-icon'
  },
  [GROUP_TYPE.ORG]: {
    name: 'Org'
  }
}

export const ENTITY_TYPE = {
  GOAL: 'goal',
  KEY_RESULT: 'key_result',
  INITIATIVE: 'initiative',
  TASK: 'task',
  IDEA_LIST: 'idea_list',
  IDEA: 'idea',
  PROJECT: 'project'
}

export const ENTITY_MAP = {
  [ENTITY_TYPE.GOAL]: {
    name: 'Goal',
    namePlural: 'Goals',
    icon: 'goal-icon-greyed',
    routeName: ROUTE_NAMES.GOAL
  },
  [ENTITY_TYPE.KEY_RESULT]: {
    name: 'Key result',
    namePlural: 'Key results',
    shortName: 'KR',
    icon: 'kr-icon-greyed',
    routeName: ROUTE_NAMES.KR
  },
  [ENTITY_TYPE.TASK]: {
    name: 'Task',
    namePlural: 'Tasks',
    routeName: ROUTE_NAMES.INITIATIVE
  },
  [ENTITY_TYPE.INITIATIVE]: {
    name: 'Initiative',
    namePlural: 'Initiatives',
    icon: 'initiative-icon',
    routeName: ROUTE_NAMES.INITIATIVE
  }
}
